import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',  // フォームの幅を100%に
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '100%',  // 入力フィールドの幅を100%に
    marginBottom: theme.spacing(2),
  },
  postalCodeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    '& .MuiTextField-root': {
      width: '30%',  // 郵便番号フィールドの幅を調整
    },
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%',  // ボタンの幅を100%に
  }
}));

const FormSeller = ({ sellerForm, setSellerForm, validateBtn, onValidate }) => {
  const [errors, setErrors] = useState({});
  const formRef = useRef(null);
  const classes = useStyles();

  const handleInputChange = (key, value) => {
    setSellerForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const postalToAddress = async () => {
    const { postalFirst, postalSecond } = sellerForm;
    const endpoint = `https://madefor.github.io/postal-code-api/api/v1/${postalFirst}/${postalSecond}.json`;

    try {
      const response = await fetch(endpoint);
      if (!response.ok) throw new Error("住所の取得に失敗しました");
      const data = await response.json();

      if (data.data && data.data.length > 0) {
        const addressData = data.data[0].ja;
        const fullAddress =
          addressData.prefecture +
          addressData.address1 +
          addressData.address2 +
          addressData.address3 +
          addressData.address4;
        handleInputChange("address", fullAddress);
      } else {
        throw new Error("住所データが見つかりません");
      }
    } catch (error) {
      console.error(error);
      alert("住所の取得に失敗しました");
    }
  };

  const handlePostalFirstChange = (value) => {
    if (value.length > 3) {
      value = value.slice(0, 3);
    }
    handleInputChange("postalFirst", value);
  };

  const handlePostalSecondChange = (value) => {
    if (value.length > 4) {
      value = value.slice(0, 4);
    }
    handleInputChange("postalSecond", value);
  };

  const validate = () => {
    const newErrors = {};

    if (!sellerForm.name) newErrors.name = "必須事項です";
    if (sellerForm.name.length > 100)
      newErrors.name = "100字以内で入力してください";
    if (!sellerForm.postalFirst || sellerForm.postalFirst.length !== 3)
      newErrors.postalFirst = "3字の郵便番号を入力してください";
    if (!sellerForm.postalSecond || sellerForm.postalSecond.length !== 4)
      newErrors.postalSecond = "4字の郵便番号を入力してください";
    if (!sellerForm.address) newErrors.address = "住所を入力してください";
    if (!sellerForm.phone) newErrors.phone = "電話番号を入力してください";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleValidation = () => {
    if (validate()) {
      onValidate();
    }
  };

  return (
    <form className={classes.form} ref={formRef} noValidate autoComplete="off">
      <TextField
        className={classes.textField}
        label="氏名（法人名）"
        fullWidth
        required
        value={sellerForm.name}
        onChange={(e) => handleInputChange("name", e.target.value)}
        error={!!errors.name}
        helperText={errors.name}
      />
      <Box className={classes.postalCodeContainer}>
        <TextField
          value={sellerForm.postalFirst}
          onChange={(e) => handlePostalFirstChange(e.target.value)}
          type="number"
          inputProps={{ maxLength: 3 }}
          error={!!errors.postalFirst}
          helperText={errors.postalFirst}
        />
        <Typography>-</Typography>
        <TextField
          value={sellerForm.postalSecond}
          onChange={(e) => handlePostalSecondChange(e.target.value)}
          type="number"
          inputProps={{ maxLength: 4 }}
          error={!!errors.postalSecond}
          helperText={errors.postalSecond}
        />
        <Button variant="contained" onClick={postalToAddress}>
          住所を取得
        </Button>
      </Box>
      <TextField
        className={classes.textField}
        label="住所"
        fullWidth
        required
        value={sellerForm.address}
        onChange={(e) => handleInputChange("address", e.target.value)}
        error={!!errors.address}
        helperText={errors.address}
      />
      <TextField
        className={classes.textField}
        label="電話番号※-（ハイフン）不要"
        fullWidth
        type="number"
        required
        value={sellerForm.phone}
        onChange={(e) => handleInputChange("phone", e.target.value)}
        error={!!errors.phone}
        helperText={errors.phone}
      />
      <TextField
        className={classes.textField}
        label="適格請求書の登録番号（任意）"
        fullWidth
        required
        value={sellerForm.invoiceRegistrationNumber}
        onChange={(e) =>
          handleInputChange("invoiceRegistrationNumber", e.target.value)
        }
        error={!!errors.invoiceRegistrationNumber}
        helperText={errors.invoiceRegistrationNumber || ""}
      />
      <Button
        className={classes.submitButton}
        variant="contained"
        color="primary"
        onClick={handleValidation}
      >
        確認
      </Button>
    </form>
  );
};

export default FormSeller;